import { PlayResponse } from '../../types';

export const localBonusFortuneWheelData: PlayResponse = {
    round: 'uid',
    step: 'uid',
    balance: 1461884222196,
    resp: {
        game_type: 'CRAZY_CRAZY_CLAW',
        win: true,
        win_amount: 300000000,
        multiplier: '3',
        win_type: 'DEFAULT',
        fortune_wheel_result: {
            sector: '2'
        },
        final_result: true
    },
    final: true
};
